import { get, post, del, put, silentClient } from './http';

const deviceEndpoints = {
  connect: screenIdNo => post('device/connect', { screen_id_no: screenIdNo }),
  details: () => get('device/aboutDevice'),
  getBookings: (date, spaceId = null) => get(`device/bookings/${date}/${spaceId && spaceId}`),
  getBooking: bookingId => get(`device/booking/${bookingId}`),
};

export const device = deviceEndpoints;
export const validatePin = pin => post('device/authenticateWithPIN', { pin });
export const deleteBooking = (bookingId, pin) => del(`device/booking/${bookingId}`, { pin });
export const getInvitees = () => get('device/invitees');
// eslint-disable-next-line
export const saveBooking = ({ title, description, start_date, end_date, invites_list, pin }) =>
  post('device/booking', { title, description, start_date, end_date, invites_list, pin });
// eslint-disable-next-line
export const updateBooking = ({ title, description, start_date, end_date, invites_list, pin }, bookingId) =>
  put(`device/booking/${bookingId}`, { title, description, start_date, end_date, invites_list, pin });
export const getSpaces = () => get('device/spaces');
export const checkIn = (bookingId, pin) => post(`device/checkin/${bookingId}`, { pin });
export const getSlideshows = () => silentClient.get('device/slideshow');
export const getCAPAlerts = () => silentClient.get('device/capAlerts');

export default {
  ...deviceEndpoints,
  validatePin,
};



// WEBPACK FOOTER //
// ./src/services/endpoints.js